<template>
<div>
	<div class="msg_box">
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">搜索结果</span>
			</div>
		</div>
		<div class="search_title">
			“{{value}}”的搜索结果
		</div>
		<div class="search_name">
			<span>适用产品信息</span>
			<span>显示{{total}}件</span>
		</div>
		<div class="search_content" v-if="goodsList.length">
			<div v-for="(item) in goodsList" :key="item.id">
				<div class="magbott20">
					<div class="search_zi clearfloat" >
						<div class="zi_left flo_lf">
							产品名称
						</div>
						<div class="zi_right flo_lf">
							<span class="tech_title2" @click="xin.goUrl('/products/'+item.id)" >{{item.model}}</span>
							<span class="tech_title2" @click="xin.goUrl('/products/'+item.id)" >{{item.title}} </span>
						</div>
					</div>
					<div v-if="item.category" class="search_zi clearfloat">
						<div class="zi_left flo_lf">
							产品应用
						</div>
						<div class="zi_right flo_lf">
							<span class="zi_qwq lan"  @click="xin.goUrl('oneDetails?cid='+item.category.id)">{{item.category.title}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<p v-else class="search_msg">
			<span class="msg_tit">搜索结果以获取有用的信息</span>没有匹配的。
		</p>
			<el-pagination  v-if="goodsList.length" class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="sizes, prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange"  :page-sizes="[10, 20, 30, 40]"  @size-change="handleSizeChange"></el-pagination>
	</div>
</div>
</template>

<script>
	export default{
		data(){
			return {
				total:0,//总数量
				pageNo:1,//当前页
				limit:10,//一页多少条
				value:'',
				goodsList:[],
			}
		},
		created(){
			this.value = this.$route.query.val.replace(/^\s*|\s*$/g,"");
			this.Postsearch();
		},
		watch:{
			$route(to,fo){
				this.value = to.query.val.replace(/^\s*|\s*$/g,"");
				this.Postsearch();
			}
		},
		methods:{
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.Postsearch();
			},
			handleSizeChange(val){
				this.limit = val;
				this.Postsearch();
			},
			async Postsearch(){
				let {value} = this;
				if(value){
					let {data} = await this.api.Postsearch({title:value,page:this.pageNo,limit:this.limit});
					this.goodsList = data.data||[];
					this.total = data.total;
					// this.limit = data.per_page;
				}else this.$message({ message: '搜索内容不能为空!', type: 'warning' });
			}
		}
	}
</script>

<style lang="scss" scoped>
.feye{
	margin: 0 auto;
	display: inline-block;
}
.zi_qwq{
	font-size: 20px;
	color: #9C9C9C;
	margin: 0 10px;
	&:hover{
		color: var(--themeColor);
	}
}
.search_msg{
	color: #666;
	.msg_tit{
		margin-right: 20px;
		font-size: 20px;
		font-weight: 500;
		text-align: left;
		color: #333333;
		line-height: 6px;
	}
}
.search_content{
	margin: 40px 0;
	border-top: 1px solid #D9D9D9;
	border-bottom: 1px solid #D9D9D9;
	padding-bottom: 70px;
	.magbott20{
		border-top: 1px solid #D9D9D9;
	}
	.search_zi{
		
		border-bottom: 1px solid #D9D9D9;
		.zi_left{
			font-size: 20px;
			color: #333;
			height: 70px;
			width: 190px;
			background: #EAF6FF;
			line-height: 70px;
			text-align: center;
		}
		.zi_right{
			line-height: 70px;
			height: 70px;
			.tech_title2{
				margin: 0 10px;
			}
		}
	}
}
.search_name{
	span{

		&:nth-child(1){
			font-size: 20px;
			font-weight: 500;
			color: #333333;
			line-height: 6px;
		}
		&:nth-child(2){
			margin: 0 20px;
			font-size: 16px;
			color: #666666;
			line-height: 6px;
		}
	}
}
	.search_title{
		margin: 50px 0;
		font-size: 30px;
		font-weight: 500;
		color: #333333;
		line-height: 6px;
	}
</style>
